
export default {
	messageList: state => state.messageIds.map(id => state.messages[id]),
	conversationList: state => state.conversationIds.map(id => state.conversations[id]),
}